import { render } from "./SidebarFilters.vue?vue&type=template&id=299fcec2"
import script from "./SidebarFilters.vue?vue&type=script&lang=js"
export * from "./SidebarFilters.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__